export default {
    appEvents: {
        lifecycle: {
            appDeepLink: {
                eventUrn: 'urn:dss:event:fed:lifecycle:app-deeplink',
                hierarchyBypass: false,
                payload: {}
            },
            appStart: {
                eventUrn: 'urn:dss:event:app-performance:app-lifecycle:lifecycle',
                hierarchyBypass: true,
                payload: {
                    operationName: 'coldStart',
                    operationState: 'start',
                    operationType: 'lifecycle'
                }
            },
            appLaunched: {
                eventUrn: 'appLaunched',
                hierarchyBypass: true,
                payload: {}
            },
            loadEnd: {
                eventUrn: 'urn:dss:event:app-performance:app-lifecycle:lifecycle',
                hierarchyBypass: true,
                payload: {
                    operationName: 'coldStart',
                    operationState: 'end',
                    operationType: 'lifecycle'
                }
            }
        }
    }
};
